export const QUERY_KEYS = {
  KOLS: 'kols',
  SESSIONS: 'sessions',
  OWNERSHIP_REQUESTS: 'ownership-requests',
} as const; 